import { render, staticRenderFns } from "./FirstComp.vue?vue&type=template&id=b0de6276&scoped=true&"
import script from "./FirstComp.vue?vue&type=script&lang=js&"
export * from "./FirstComp.vue?vue&type=script&lang=js&"
import style0 from "./FirstComp.vue?vue&type=style&index=0&id=b0de6276&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0de6276",
  null
  
)

export default component.exports